<template>
  <div id="app">
<!--    <keep-alive>
      <router-view/>
    </keep-alive>-->
    <router-view/>
  </div>
</template>

<style lang="less">
@import url('./assets/less/main/app.less');
.el-table th.gutter{
  display: table-cell!important;
}
</style>
<script>

  export default {
    name:'app',
    provide(){
      return {
        reload:this.reload
      }
    },
    data(){
      return{
        isRouterAlive:true
      }
    },
    methods:{
      reload(){
        this.isRouterAlive=false
        this.$nextTick(function (){
          this.isRouterAlive=true
        })
      }
    },
    watch:{
      $route(to,from){
        console.log(localStorage.getItem('authed'))
        let permanentCodeResponse = JSON.parse(localStorage.getItem('permanentCodeResponse'))
        let addressSecret =localStorage.getItem('addressSecret')
        let usedMemberIds=JSON.parse(localStorage.getItem('usedMemberIds'))
        console.log('usedMemberIds',usedMemberIds)
        let uid  = localStorage.getItem('_uid');
        let mainId =  localStorage.getItem('_mainId');
        console.log(!permanentCodeResponse||!addressSecret||!usedMemberIds)
        if ((!permanentCodeResponse||!addressSecret||!usedMemberIds)&&mainId&&uid){
          console.log('to1',to.path);
          if (to.path!=='/authorization'){
            this.$router.replace("/authorization" )
            console.log('to2',to.path);
          }
        }
        console.log('from',from)
      }
    }

  }
</script>